export default __webpack_public_path__ + "static/Gas_Ball-b27503face91b4e67560a0e18b313364.png";